// sets up stereographic image switching with speed slider

// imports
import React from 'react';
import {Stereoimage} from './utils/imageSwitch.js';
import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';

//Class component for buliding sliders and stereoview
export class Stereospeedslider extends React.Component {
    constructor(props) {
        super(props);
        //sets initial value for speed slider
        this.state = {value: 10};
        console.log('I was initialized');
    }

    //function for rendering slider changes
    handleOnChange = (e) =>{
        this.setState({value: e.target.value});
    }
    onValueChange =  value =>{
        // sets new rotation state property
        this.setState({value: value})
      }

    render(){
        return(
                <div id='stereo'>
                    <Stereoimage slideInt = {this.state.value} image1={this.props.image1} image2={this.props.image2} />
                    <Typography
                    variant="overline"
                    id="speedLabel"
                  >
                    <strong><u>Speed Control</u> ({this.state.value} switches/second)</strong>
                  </Typography>
                    <Slider
                    value={this.state.value}
                    min={1}
                    max={30}
                    step={1}
                    aria-labelledby="Speed control"
                    id ='speedSlider'
                    onChange={(e,value) => this.onValueChange(value)}
                  />
                </div>
        )
    }

}